import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {DigitalizedSignatureValues} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import RepresentativeSign from './InnerFormRepresentativeSign';
import {FieldShape} from 'commons/shapes';
import {formValidator} from 'commons/utils/Functions';
import {Messages} from 'commons/constants';

RepresentativeSignForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired)
        .isRequired,
    signature: PropTypes.any,
    signed: PropTypes.bool.isRequired,
};

const FormControl = withFormik<
    InferPropTypes<typeof RepresentativeSignForm.propTypes>,
    DigitalizedSignatureValues
>({
    mapPropsToErrors: () => {
        return {
            signature: '',
            informationCheck: '',
            signed: '',
        };
    },
    mapPropsToValues: (props) => {
        return {
            signature: props.signature || '',
            informationCheck: props.signed,
            signed: props.signed,
        };
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: DigitalizedSignatureValues, props) => {
        const errors: FormikErrors<DigitalizedSignatureValues> = {};
        formValidator(props.fields, errors, values);
        if (!values.signature) {
            errors.signature = Messages.SIGNATURE_NOT_CAPTURED;
        }
        if (!values.informationCheck) {
            errors.informationCheck = Messages.ACCEPT_THE_TERMS;
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(RepresentativeSign);

function RepresentativeSignForm(
    props: InferPropTypes<typeof RepresentativeSignForm.propTypes>
) {
    const {submitHandler, fields, signed, signature} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl fields={fields} signed={signed} signature={signature} submitHandler={submitHandler} />
    );
}

export default RepresentativeSignForm;
